import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { rolesOrder } from "@api";
import { setAlert } from '@store/alerts.reducer';

const showErrorAlert = (dispatch) => {
    dispatch(setAlert({
      title: 'Ошибка',
      text: 'Не удалось загрузить роли',
      type: 'error'
    }));
};

export const fetchAllRoles = createAsyncThunk(
  "allRoles/fetchAllRoles",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await rolesOrder.getList();
      if (response.status !== 200) {
        showErrorAlert(dispatch)
        return rejectWithValue('Ошибка сервера: неверный статус ответа');
      }
      return response.data;
    } 
    catch (error) {
        showErrorAlert(dispatch)
        return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  data: [],
  status: "idle",
  error: null,
};

const allRolesSlice = createSlice({
  name: 'allRoles',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllRoles.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchAllRoles.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload;
      })
      .addCase(fetchAllRoles.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export default allRolesSlice.reducer;